/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiKeyResponse } from '../../models/api-key-response';

export interface MembersApiKeyPut$Params {}

export function membersApiKeyPut(
  http: HttpClient,
  rootUrl: string,
  params?: MembersApiKeyPut$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ApiKeyResponse>> {
  const rb = new RequestBuilder(rootUrl, membersApiKeyPut.PATH, 'put');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApiKeyResponse>;
      }),
    );
}

membersApiKeyPut.PATH = '/members/api-key';
